<template>
  <select-delivery-method-component formAction="authentication/selectphones"/>
</template>

<style>
</style>

<script> 
  import ContextualHelp from 'components/popper-help';
  import SelectDeliveryMethod from './select-delivery-method';

  export default {
    name: 'SelectDeliveryMethodChallenge',
    components: {
      'contextual-help-component': ContextualHelp,
      'select-delivery-method-component': SelectDeliveryMethod
    }
  }
</script>